import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { tap, catchError, shareReplay } from "rxjs/operators";
import { CommonService } from './common.service';
import { IProfile } from '../interfaces/[Interface-based]/profile.interface';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private _employeeApi = '/api/employee/';

  constructor(
    private _http: HttpClient,
    private _commonService: CommonService
  ) {}

  getEmployee(employeeSalesSessionId: number): Observable<IProfile> {
    const url = `${this._employeeApi}${employeeSalesSessionId}`;

    return this._http.get<IProfile>(url);
  }
}
